import common from './common.json';
import createSpace from './create-space.json';
import editSpace from './edit-space.json';
import createBookingRules from './create-booking-rules.json';
import bookingRules from './booking-rules.json';

export default {
  common,
  createSpace,
  createBookingRules,
  editSpace,
  bookingRules,
};
